import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, LoaderCircle, RefreshCw } from "lucide-react";
import { API_BASE } from "../api";

export function ServerLogExplorerPage() {
  const [revision, setRevision] = useState(0);
  const [loading, setLoading] = useState(true);
  return (
    <div className="flex min-h-0 min-w-0 flex-1 flex-col gap-3 overflow-hidden p-3 sm:p-5">
      <header className="flex shrink-0 flex-wrap items-center justify-between gap-3">
        <div className="flex flex-wrap items-center gap-3">
          <Link className="button" to="/settings/logs">
            <ArrowLeft size={16} aria-hidden="true" /> Server logs
          </Link>
          <h2 className="text-xl font-bold">Log explorer</h2>
        </div>
        <button
          type="button"
          className="button"
          onClick={() => {
            setLoading(true);
            setRevision((value) => value + 1);
          }}
        >
          <RefreshCw size={16} aria-hidden="true" /> Reload explorer
        </button>
      </header>
      <section
        className="relative min-h-0 flex-1 overflow-hidden rounded-xl border border-stone-200 bg-white dark:border-white/10"
        aria-busy={loading}
      >
        {loading && (
          <div
            role="status"
            className="absolute inset-0 flex items-center justify-center gap-2 bg-white text-sm text-stone-600"
          >
            <LoaderCircle
              className="animate-spin"
              size={18}
              aria-hidden="true"
            />{" "}
            Loading log explorer…
          </div>
        )}
        <iframe
          key={revision}
          title="VictoriaLogs log explorer"
          src={`${API_BASE}/admin/log-explorer/select/vmui/`}
          className="size-full border-0"
          onLoad={() => setLoading(false)}
        />
      </section>
    </div>
  );
}
